import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Assuming you have a similar function to log actions

const sendChatMessage = async (
  sender_oid,
  folderid,
  folderconvid,
  content,
  receiver,
  token,
  prefix
) => {
  // Define the endpoint URL
  const url = prefix + `folders/${folderid}/message`;

  // Define the request body
  const body = {
    content: content,
    receiver: receiver,
    sender_oid: sender_oid,
  };

  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    // Check if the user is authenticated
    const auth = getAuthCentral();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      console.error("User not logged in");
      return "User not logged in";
    }

    // Get Firestore references for the user
    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      return "User document not found";
    }

    const org_id = userSnapshot.get("org_id");
    const responseText = await response.text();

    // Add log document (avoid passing full document references)
    await addLogDocument(
      url,
      prefix,
      userRef, // Only log the userRef ID
      org_id,
      response.status.toString(),
      folderid, // folderid
      "", // docid
      JSON.stringify(body), // request body as string
      responseText,
      "POST"
    );

    // Check if the request was successful
    if (response.ok) {
      // Handle successful response
      return "";
    } else {
      // Handle error response
      console.error(`Failed to send chat message: ${response.status}`);
      return "";
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
};

export default sendChatMessage;
